import React from 'react';
const points = ['Sei stanca di perdere clienti perché non hai una programmazione seria e professionale.', 'Arrivi a casa dopo il lavoro e devi ancora metterti a scrivere la sessione del giorno dopo.', 'Senti di dare sempre i soliti esercizi e i tuoi allievi hanno smesso di migliorare.', 'Hai bisogno di dimostrare risultati ai tuoi allievi con una struttura chiara, non con le parole.'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-111">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-112"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-113">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-12 text-center tracking-tight" data-id="element-114">
          Questo sistema è per te se...
        </h2>

        <div className="space-y-4" data-id="element-115">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-lg" data-id="element-116">
              <div className="w-8 h-8 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 group-hover:bg-check-green group-hover:border-check-green transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-117">
                <span className="text-check-green group-hover:text-white text-sm font-bold transition-colors" data-id="element-118">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-119">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}